export class Colors {
    static color_primary: string = 'primary';
    static color_accent: string = 'accent';
    static color_warn: string = 'warn';
}